import { render, staticRenderFns } from "./overview.vue?vue&type=template&id=3936d0a0&scoped=true"
import script from "./overview.vue?vue&type=script&lang=ts"
export * from "./overview.vue?vue&type=script&lang=ts"
import style0 from "./overview.vue?vue&type=style&index=0&id=3936d0a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3936d0a0",
  null
  
)

export default component.exports